import type { ArchivedClientRow } from '../api/queries'
import { Link } from 'react-router'
import { useArchivedClients } from '../api/queries'
import { fmtDateTime } from '../format'

/** The collapsed "Archived clients (n)" node at the bottom of the tree's Clients section (§3.14). Reader roles only. */
export function ArchivedClientsNode({ enabled, rowClass }: { enabled: boolean, rowClass: string }) {
  const q = useArchivedClients(enabled)
  const rows: ArchivedClientRow[] = q.data ?? []
  if (!enabled || rows.length === 0)
    return null
  return (
    <li>
      <details data-testid="tree-archived-clients">
        <summary className={`${rowClass} flex cursor-pointer items-center gap-2 rounded-md px-3 text-sm text-quaternary hover:bg-primary_hover`}>{`Archived clients (${rows.length})`}</summary>
        <ul className="mb-1">
          {rows.map(cl => (
            <li key={cl.id}>
              <Link to={`/c/${cl.id}`} className={`${rowClass} flex items-center gap-2 rounded-md px-3 pl-7 text-sm text-quaternary hover:bg-primary_hover`} data-testid="tree-archived-client" title={`Archived ${fmtDateTime(cl.archived_at)}${cl.archived_by ? ` by ${cl.archived_by}` : ''}`}>
                <span className="truncate">{cl.name}</span>
                <span className="ml-auto text-xs">{`${cl.file_count} ${cl.file_count === 1 ? 'file' : 'files'}`}</span>
              </Link>
            </li>
          ))}
        </ul>
      </details>
    </li>
  )
}
